import AnalyticsClient, {
  envType,
  originType,
  userType,
} from '@atlassiansox/analytics-web-client';
import Cookie from 'js-cookie';

const init = () => {
  const hostname = window.location.hostname;
  const isDev = hostname.includes('dev');
  const isStaging = hostname.includes('staging') || hostname.includes('stg');
  const isProd = hostname.includes('prod');

  const analyticsClient = new AnalyticsClient(
    {
      env: isProd
        ? envType.PROD
        : isStaging
        ? envType.STAGING
        : isDev
        ? envType.DEV
        : envType.LOCAL,
      product: 'productPlaceholder',
      version: '1.0.0',
      origin: originType.WEB,
    },
    { useLegacyUrl: true },
  );

  const aaid = Cookie.get('aaid');

  if (aaid) {
    analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, aaid);
  }

  return analyticsClient;
};

let analyticsClient: AnalyticsClient | null = null;

export const getAnalyticsWebClient = (): AnalyticsClient => {
  if (analyticsClient === null) {
    analyticsClient = init();
  }
  return analyticsClient;
};
